<template>
  <div class="imported-products" v-if="show">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <ProductForm
      :show="productForm.show"
      :product="productForm.product"
      v-on:cancel="hideForm"
      v-on:productUpdated="productUpdated"
      v-on:productAdded="productAdded"
    />
    <DataTable
      :value="productsList"
      :filters.sync="filters"
      filterDisplay="row"
      :loading="loading"
      class="p-datatable-sm"
      sortMode="single"
      responsiveLayout="scroll"
      :scrollable="true"
      scrollHeight="flex"
      :paginator="true"
      :rows="perPage"
      :rowsPerPageOptions="[10, 25, 50, 100]"
      :lazy="true"
      :totalRecords="totalRecords"
      @filter="loadProducts"
      @sort="loadProducts"
      @page="loadProducts"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Mostrar de {first} a {last} de {totalRecords} dados"
    >
      <template #empty> Nada a mostrar. </template>
      <template #loading> A carregar. Por favor Aguarde... </template>
      <template #header>
        <div class="table-header p-d-flex p-jc-between p-ai-center">
          <span style="font-weight: bold; font-size: 1.1rem;">Produtos Relacionados</span>
          <Button
            label="Adicionar Produto"
            icon="pi pi-plus"
            class="p-button-sm p-button-success"
            @click="addNewProduct"
            v-if="can('createUpdateParts')"
          />
        </div>
      </template>
      <Column
        field="api_id"
        header="Sinc. Loja"
        sortable
        :headerStyle="{ 'min-width': '9%', 'max-width': '9%' }"
        :filterHeaderStyle="{ 'min-width': '9%', 'max-width': '9%' }"
        :bodyStyle="{ 'min-width': '9%', 'max-width': '9%' }"
        :showFilterMenu="false"
      >
        <template #body="slotProps">
          <span
            class="clickable-item"
            @click="edit(slotProps.data)"
            v-if="can('createUpdateParts')"
          >
            <template v-if="slotProps.data.api_id != null">
              <i class="pi pi-check-circle text-green-500"></i>
            </template>
            <template v-else>
              <i class="pi pi-times-circle text-red-400"></i>
            </template>
          </span>
          <span v-else>
            <template v-if="slotProps.data.api_id != null">
              <i class="pi pi-check-circle text-green-500"></i>
            </template>
            <template v-else>
              <i class="pi pi-times-circle text-red-400"></i>
            </template>
          </span>
        </template>
        <template #filter>
        </template>
      </Column>
      <Column
        field="reference"
        header="Referência"
        sortable
        filterField="reference"
        :headerStyle="{ 'min-width': '8%', 'max-width': '8%' }"
        :filterHeaderStyle="{ 'min-width': '8%', 'max-width': '8%' }"
        :bodyStyle="{ 'min-width': '8%', 'max-width': '8%' }"
      >
        <template #body="slotProps">
          <span
            class="clickable-item"
            @click="edit(slotProps.data)"
            v-if="can('createUpdateParts')"
          >
            {{ slotProps.data.reference ?? "_______" }}
          </span>
          <span v-else>
            {{ slotProps.data.reference ?? "" }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @input="filterCallback()"
          />
        </template>
      </Column>
      <Column
        field="family_id"
        header="Família"
        sortable
        filterField="family_id"
        :headerStyle="{ 'min-width': '12%', 'max-width': '12%' }"
        :filterHeaderStyle="{ 'min-width': '12%', 'max-width': '12%' }"
        :bodyStyle="{ 'min-width': '12%', 'max-width': '12%' }"
      >
        <template #body="slotProps">
          <span
            class="clickable-item"
            @click="edit(slotProps.data)"
            v-if="can('createUpdateParts')"
          >
            {{ slotProps.data.family ? slotProps.data.family.name : "_______" }}
          </span>
          <span v-else>
            {{ slotProps.data.family ? slotProps.data.family.name : "" }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <Dropdown
            v-model="filterModel.value"
            @input="filterCallback()"
            dataKey="id"
            :options="productFamily"
            optionValue="id"
            optionLabel="name"
            class="p-column-filter"
            :showClear="true"
          >
          </Dropdown>
        </template>
      </Column>
      <Column
        field="description"
        filterField="description"
        header="Descrição"
        sortable
        :headerStyle="{ 'min-width': '20%', 'max-width': '20%' }"
        :filterHeaderStyle="{ 'min-width': '20%', 'max-width': '20%' }"
        :bodyStyle="{ 'min-width': '20%', 'max-width': '20%' }"
      >
        <template #body="slotProps">
          <span
            class="clickable-item"
            @click="edit(slotProps.data)"
            v-if="can('createUpdateParts')"
          >
            {{ slotProps.data.description ?? "_______" }}
          </span>
          <span v-else>
            {{ slotProps.data.description ?? "" }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @input="filterCallback()"
          />
        </template>
      </Column>
      <Column
        field="pivot.location_no"
        filterField="pivot.location_no"
        header="Localização"
        sortable
        :headerStyle="{ 'min-width': '7%', 'max-width': '7%' }"
        :filterHeaderStyle="{ 'min-width': '7%', 'max-width': '7%' }"
        :bodyStyle="{ 'min-width': '7%', 'max-width': '7%' }"
      >
        <template #body="slotProps">
          <span
            class="clickable-item"
            @click="edit(slotProps.data)"
            v-if="can('createUpdateParts')"
          >
            {{ slotProps.data.location_no ?? "_______" }}
          </span>
          <span v-else>
            {{ slotProps.data.location_no ?? "" }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @input="filterCallback()"
          />
        </template>
      </Column>
      <Column
        field="cost_price"
        filterField="cost_price"
        header="Preço de Custo"
        sortable
        :headerStyle="{ 'min-width': '7%', 'max-width': '7%' }"
        :filterHeaderStyle="{ 'min-width': '7%', 'max-width': '7%' }"
        :bodyStyle="{ 'min-width': '7%', 'max-width': '7%' }"
      >
        <template #body="slotProps">
          <span
            class="clickable-item"
            @click="edit(slotProps.data)"
            v-if="can('createUpdateParts')"
          >
            {{ slotProps.data.cost_price ?? "_______" }} €
          </span>
          <span v-else> {{ slotProps.data.cost_price ?? "" }} € </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @input="filterCallback()"
          />
        </template>
      </Column>
      <Column
        field="sale_price"
        filterField="sale_price"
        header="Preço de Venda"
        sortable
        :headerStyle="{ 'min-width': '7%', 'max-width': '7%' }"
        :filterHeaderStyle="{ 'min-width': '7%', 'max-width': '7%' }"
        :bodyStyle="{ 'min-width': '7%', 'max-width': '7%' }"
      >
        <template #body="slotProps">
          <span
            class="clickable-item"
            @click="edit(slotProps.data)"
            v-if="can('createUpdateParts')"
          >
            {{ slotProps.data.sale_price ?? "_______" }} €
          </span>
          <span v-else> {{ slotProps.data.sale_price ?? "" }} € </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @input="filterCallback()"
          />
        </template>
      </Column>
      <Column
        field="stock"
        filterField="stock"
        header="Stock"
        sortable
        :headerStyle="{ 'min-width': '8%', 'max-width': '8%' }"
        :filterHeaderStyle="{ 'min-width': '8%', 'max-width': '8%' }"
        :bodyStyle="{ 'min-width': '8%', 'max-width': '8%' }"
      >
        <template #body="slotProps">
          <span
            class="clickable-item"
            @click="edit(slotProps.data)"
            v-if="can('createUpdateParts')"
          >
            {{ slotProps.data.stock ?? "_______" }}
          </span>
          <span v-else>
            {{ slotProps.data.stock ?? "" }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @input="filterCallback()"
          />
        </template>
      </Column>

      <Column
        field="remote_stock"
        filterField="remote_stock"
        header="Stock Remoto"
        sortable
        :headerStyle="{ 'min-width': '8%', 'max-width': '8%' }"
        :filterHeaderStyle="{ 'min-width': '8%', 'max-width': '8%' }"
        :bodyStyle="{ 'min-width': '8%', 'max-width': '8%' }"
      >
        <template #body="slotProps">
          <span
            class="clickable-item"
            @click="edit(slotProps.data)"
            v-if="can('createUpdateParts')"
          >
            {{ slotProps.data.remote_stock ?? "_______" }}
          </span>
          <span v-else>
            {{ slotProps.data.remote_stock ?? "" }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @input="filterCallback()"
          />
        </template>
      </Column>

      <Column
        field="last_price_update"
        filterField="last_price_update"
        header="Última Atualização de Preço"
        sortable
        :headerStyle="{ 'min-width': '9%', 'max-width': '9%' }"
        :filterHeaderStyle="{ 'min-width': '9%', 'max-width': '9%' }"
        :bodyStyle="{ 'min-width': '9%', 'max-width': '9%' }"
      >
        <template #body="slotProps">
          <span
            class="clickable-item"
            @click="edit(slotProps.data)"
            v-if="can('createUpdateParts')"
          >
            {{ slotProps.data.last_price_update ?? "_______" }}
          </span>
          <span v-else>
            {{ slotProps.data.last_price_update ?? "" }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @input="filterCallback()"
          />
        </template>
      </Column>
      <Column
        field="website_update"
        filterField="website_update"
        header="Última Atualização do Site"
        sortable
        :headerStyle="{ 'min-width': '9%', 'max-width': '9%' }"
        :filterHeaderStyle="{ 'min-width': '9%', 'max-width': '9%' }"
        :bodyStyle="{ 'min-width': '9%', 'max-width': '9%' }"
      >
        <template #body="slotProps">
          <span
            class="clickable-item"
            @click="edit(slotProps.data)"
            v-if="can('createUpdateParts')"
          >
            {{ slotProps.data.website_update ?? "_______" }}
          </span>
          <span v-else>
            {{ slotProps.data.website_update ?? "" }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @input="filterCallback()"
          />
        </template>
      </Column>
      <Column
        field="show_website"
        header="Ativo Loja"
        sortable
        filterField="show_website"
        :headerStyle="{ 'min-width': '8%', 'max-width': '8%' }"
        :filterHeaderStyle="{ 'min-width': '8%', 'max-width': '8%' }"
        :bodyStyle="{ 'min-width': '8%', 'max-width': '8%' }"
      >
        <template #body="slotProps">
          {{ slotProps.data.show_website == 1 ? "Sim" : "Não" }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <Dropdown
            v-model="filterModel.value"
            @input="filterCallback()"
            :options="[
              { value: 0, label: 'Não' },
              { value: 1, label: 'Sim' },
            ]"
            optionValue="value"
            optionLabel="label"
            class="p-column-filter"
            :showClear="true"
          >
          </Dropdown>
        </template>
      </Column>
      <Column
        field="active"
        header="Ativo"
        sortable
        filterField="active"
        :headerStyle="{ 'min-width': '8%', 'max-width': '8%' }"
        :filterHeaderStyle="{ 'min-width': '8%', 'max-width': '8%' }"
        :bodyStyle="{ 'min-width': '8%', 'max-width': '8%' }"
      >
        <template #body="slotProps">
          {{ slotProps.data.active == 1 ? "Sim" : "Não" }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <Dropdown
            v-model="filterModel.value"
            @input="filterCallback()"
            :options="[
              { value: 0, label: 'Não' },
              { value: 1, label: 'Sim' },
            ]"
            optionValue="value"
            optionLabel="label"
            class="p-column-filter"
            :showClear="true"
          >
          </Dropdown>
        </template>
      </Column>
    </DataTable>
  </div>
</template>
<script>
import sparsService from "../../services/spars.service";
import ProductForm from "../products/ProductForm.vue";
import { FilterMatchMode } from "primevue/api";
export default {
  name: "ImportedProducts",
  props: ["show", "equipament"],
  components: {
    ProductForm,
  },
  watch: {
    show: {
      immediate: true,
      async handler(newVal) {
        if (newVal === true) {
          this.loading = true;
          await this.loadProducts();
          this.loading = false;
        }
      }
    }
  },
  async created() {
    this.loading = true;
    this.productFamily = await sparsService.getProductFamiliesByStatus(1);
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      productsList: [],
      productFamily: [],
      totalRecords: 0,
      perPage: 25,
      currentPage: 1,
      has_api_id: null,
      filters: {
        reference: { value: null, matchMode: FilterMatchMode.CONTAINS },
        family_id: { value: null, matchMode: FilterMatchMode.EQUALS },
        active: { value: null, matchMode: FilterMatchMode.EQUALS },
        show_website: { value: null, matchMode: FilterMatchMode.EQUALS },
        description: { value: null, matchMode: FilterMatchMode.CONTAINS },
        "pivot.location_no": {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
        long_description: { value: null, matchMode: FilterMatchMode.CONTAINS },
        cost_price: { value: null, matchMode: FilterMatchMode.CONTAINS },
        sale_price: { value: null, matchMode: FilterMatchMode.CONTAINS },
        stock: { value: null, matchMode: FilterMatchMode.CONTAINS },
        remote_stock: { value: null, matchMode: FilterMatchMode.CONTAINS },
        last_price_update: { value: null, matchMode: FilterMatchMode.CONTAINS },
        website_update: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      productForm: {
        show: false,
        product: null,
      },
    };
  },
  methods: {
    async loadProducts(event = {}) {
      this.loading = true;

      try {
        const page = event.page ? event.page + 1 : 1;
        const perPage = event.rows ? event.rows : this.perPage;

        const params = {
          page,
          per_page: perPage
        };

        for (let key in this.filters) {
          const filterValue = this.filters[key].value;
          if (filterValue !== null && filterValue !== '') {
            if (key === 'pivot.location_no') {
              params['pivot_location_no'] = filterValue;
            } else {
              params[key] = filterValue;
            }
          }
        }

        const response = await sparsService.getEquipamentProducts(this.equipament.id, params);

        if (response) {
          this.productsList = response.data || [];
          this.totalRecords = response.total || 0;
          this.currentPage = response.current_page || 1;
          this.perPage = response.per_page || 25;
        } else {
          this.productsList = [];
          this.totalRecords = 0;
          this.currentPage = 1;
        }
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar dados',
          life: 3000
        });
      } finally {
        this.loading = false;
      }
    },
    hideForm() {
      this.productForm = {
        show: false,
        product: null,
      };
    },
    edit(product) {
      return (this.productForm = {
        show: true,
        product: product,
      });
    },
    async productUpdated() {
      await this.loadProducts();
      return this.hideForm();
    },
    addNewProduct() {
      this.productForm = {
        show: true,
        product: null,
      };
    },
    async productAdded(newProduct) {
      this.loading = true;
      try {
        const response = await sparsService.newEquipamentsProduct({
          equipment_id: this.equipament.id,
          product_id: newProduct.id,
          location_no: newProduct.location_no || "",
        });

        if (response) {
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Produto adicionado e associado ao equipamento com sucesso",
            life: 3000,
          });
          await this.loadProducts();
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Erro ao associar o produto ao equipamento",
            life: 3000,
          });
        }
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Erro ao associar o produto ao equipamento",
          life: 3000,
        });
      } finally {
        this.loading = false;
        this.hideForm();
      }
    },
  },
};
</script>
<style>
.imported-products {
  position: relative;
  height: 100%;
}
</style>
